/* Zumpo/Code board and its Code rows. */
.board {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--zumpo-space-8);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-16);
}

.digits {
  display: flex;
  gap: var(--zumpo-space-8);
}

.small {
  gap: var(--zumpo-space-4);
}

.small .row {
  gap: var(--zumpo-space-8);
}

.small .digits {
  gap: var(--zumpo-space-4);
}

/* The board a real keyboard types into shows when it has the focus. */
.board:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}
